const strings = {
  document: 'CPF',
  email: 'E-mail',
  phone: 'Celular',
  situation: 'Situação',
  cargo: 'Cargo',
  adminInfo: 'Perfil Administrativo',
  agpro: 'agPRO',
  userInfoTitle: 'Dados do usuário',
  validacaoAuditoriaAtuomatica: 'Validação/auditoria automática',
}

export default strings
